module.exports = __webpack_public_path__ + "static/Calibre-MediumItalic-6eb2ac5a1d38f19c7085b131356b355e.ttf";